import { useTranslation } from '../../hooks/useTranslation'
import Overlay, { subClass } from './Overlay'

export default function ErrorOverlay({ message }: { message: string }) {
  const { t } = useTranslation()

  return (
    <Overlay icon="✕" iconClass="bg-danger/10 text-danger border-danger/25">
      <div className="mb-2.5 text-center font-volte text-[clamp(1.4rem,3.2vh,2rem)] text-danger">
        {t('payment-error-headline')}
      </div>
      <div className={subClass}>{t('payment-error-sub')}</div>
      <div className="mt-[clamp(10px,1.8vh,20px)] rounded-[20px] border border-danger/20 bg-danger/[0.07] px-4 py-[5px] font-volte text-[clamp(0.6rem,1.1vh,0.75rem)] tracking-[0.08em] text-danger">
        {message}
      </div>
    </Overlay>
  )
}
